<template>
<ValidationObserver  v-slot="{ handleSubmit }">  
      <CForm  
       
      >
      <!-- @submit.prevent="alertValue==null ?
           handleSubmit(confirmPricing) : alertValue=alertValue
        " -->

    <CCard>
       <header class="card-header grey-header">
      <div class="row flex-flow-column">
        <div class="col">
          <strong>{{ $t("addNewPricing.title") }}</strong>
        </div>
        <p class="desc" v-if="selectedPricing">
         {{ $t("addNewPricing.editDesc") }}
        </p>
        <p class="desc" v-else>
         {{ $t("addNewPricing.desc") }}
        </p>
      </div>
    </header>
      <CCardBody>
        
        <!-- <div v-if="selectedPricing">
          <pre class="language-json"><code>{{selectedPricing}}</code></pre>
        </div>
         <br />
        <div v-if="pricingList.length>0">
          <pre class="language-json"><code>{{pricingList}}</code></pre>
        </div>
        <br />
        <br /> -->
        <!-- <div v-if="selectedPricingList.length>0">
          <pre class="language-json"><code>{{selectedPricingList}}</code></pre>
        </div>-->

        <!-- <CRow> -->
          <!-- <CCol>
            <Strong>{{$t('addNewPricing.slctAgnt')}}</Strong>
          </CCol> -->
          <!-- <CCol> -->
     

                  <div class="sha-table-wrap">
              <div v-if="selectedPricing">
            <div class="text-center position-relative">
              <Strong class="a-title-name">{{
                selectedPricing.agentName
              }}</Strong>
                
                <div class="info-message"   v-c-tooltip.hover="{content:$t('addNewPricing.anyChange')}">
                    <img src="@imgPath/img/svg/icons/info-icon.svg" alt="">
                </div>
              <!-- <input type="text" :value="selectedPricing.agentName" /> -->
            </div>
          </div>
            <div v-else>
              <CRow>
<!--              <CCol>-->
<!--            <Strong>{{$t('addNewPricing.slctAgnt')}}</Strong>-->
<!--          </CCol>-->
          <CCol md="6" class="bs-input mb-10px label-none z-index-9999" >
              <cAgent
              :b2bCodeToSelectAgent="GET_APPROVE_AGENT_RES&&GET_APPROVE_AGENT_RES.id?GET_APPROVE_AGENT_RES.id:null"
                agentType="null"
                v-model="agents"
                  :rules='"required"'
                :isMultiple="false"
              :label="$t('addNewPricing.slctAgnt')"
                :isInactiveusers="false"
                @input="getB2bid"
                :unAssignedAgentList=" assignedAgentList &&assignedAgentList.length>0?assignedAgentList:[]"
              />
              </CCol>
              </CRow>
            </div>
             
          <!-- </CCol> -->
        <!-- </CRow> -->
    


         <div class="header">
            <div class="title">

              {{$t('addNewPricing.status')}}
             
            </div>
            <div class="title">
           {{$t('addNewPricing.booking')}}
            </div>
          </div>

        <div v-if="selectedPricingList&&selectedPricingList.length>0 && selectedPricingList[0] && selectedPricingList[0].tiers.length">
          <!-- <CRow>
          <CCol>
            <Strong>{{$t('addNewPricing.tiers')}}</Strong>
          </CCol>
        </CRow> -->
       
        <div  v-for="(tier,index) in selectedPricingList[0].tiers"   :key="index+'tier'"  class="body">
            <div class="v-content">
                <CSwitch
                    v-bind="labelIcon"
                class="mx-1"
                color="success"
                variant="3d"
                type="checkbox"
                 :checked.sync="tier.isEnable"
                  @update:checked="onToggleSwitch"
              ></CSwitch>
              <div class="a-name">{{tier.tierName}}</div>
            </div>
            <div    class="v-content " v-if="tier.isEnable">
              <div   data-v-c2da5fea="" class='date-pick ' :class="{'disable':!tier.isEnable}">
               <!-- <HotelDatePicker  v-if="tier.isEnable"
                  :startingDateValue="new Date(tier.fromDate)"
                  :startDate="new Date()"
                  :endingDateValue="new Date(tier.toDate)"
                 
                  @check-in-changed="getFromDate($event, tier)"
                  @check-out-changed="getToDate($event, tier)"
                  :displayClearButton="false"
                  :i18n="assigni18nObjByLang(tier)"
                  :hoveringTooltip="false"
                    :minNights="0"
                    :showYear="true"
                /> -->

                <div class="ext-date-wrapper box-shadow left z-index-99">
                                                 <v-md-date-range-picker
    :start-date="tier.fromDate?tier.fromDate.toString():new Date().toString()"
    :end-date="tier.toDate?tier.toDate.toString():new Date().toString()"
    :disableBefore="tier.fromDate.toString()"
    :autoApply="true"
    :showYearSelect="true"
    :maxYear="getMaxYear()"
    :minYear="getMinYear()"
    @change="onChangeDate($event, tier)"
            :allowPastPresets="false"

  >
  <template slot="input">
       <datePickerInput :fromDate="tier.fromDate?tier.fromDate:null" :toDate="tier.toDate?tier.toDate:null" :fromLabel="$t('addNewPricing.fromLabel')" :toLabel="$t('addNewPricing.toLabel')"/>
    
  </template>
  </v-md-date-range-picker></div>
              
              </div>
            </div>
          </div>

          
          <!-- <CDataTable
            :fields="pricingFields"
            :items="selectedPricingList[0].tiers!=null?selectedPricingList[0].tiers:[]"
            :loading="selectedPricingList[0].tiers.length>0?false:true"
          >
            <template #pricingname="{item}">
              <td class="py-2">
                 <div v-for="(tier,index) in item" :key="index">
            {{item.tiers}}
                {{tier}}

                <CSwitch
                  class="mx-1"
                  color="success"
                  variant="3d"
                  type="checkbox"
                  :checked.sync="item.isEnable"
                ></CSwitch>

                <label>{{item.tierName}}</label>
                </div> 
              </td>
            </template>

            <template #bookingDate="{item}">
              <td class="py-2">
                <div v-for="(tier,index) in item.tiers" :key="index"> 
                <div v-bind:class="{ 'disable': !item.isEnable }">
                  <HotelDatePicker
                    :startingDateValue="new Date(item.fromDate)"
                    :startDate="new Date()"
                    :endingDateValue="new Date(item.toDate)"
                    format="DD MMM YYYY"
                    @check-in-changed="getFromDate($event,item)"
                    @check-out-changed="getToDate($event,item)"
                    :displayClearButton="false"
                    :i18n="assigni18nObjByLang(item)"
                    :hoveringTooltip="false"
                     
                  />
                </div>
              </div> 
              </td>
            </template>
          </CDataTable> -->
        </div>
                  </div>
      </CCardBody>
      <CAlert v-if="alertValue" show color="danger">
                      <div  v-if="alertValue&&alertValue.hasOwnProperty('valueList')">
                <p  v-for="(value,index) in alertValue.valueList" :key="index">
                        {{value}}
                      </p>
                      </div>
                      <div v-if="alertValue&&alertValue.hasOwnProperty('codeList')">
                      <span>{{$t("cAlert.errorCode")+' : '}}</span><span  v-for="(code,index) in alertValue.codeList" :key="index">
                        {{code +' '}}
                      </span>
                      </div>
                            <div  v-if="alertValue&&alertValue.constructor==String">
                <p  >
                        {{alertValue}}
                      </p>
                      </div>
                      </CAlert>
     <footer class="card-footer d-flex justify-content-end">
      <div class="row">
        <div class="col">
          <button
            type="cancel"
            class="btn action-c-btn btn-danger"
            @click="navToAssPricWhileCancel"
          >
            <img src="/img/close.f776d69c.svg" />
            {{ $t("addNewPricing.cancel") }}
          </button>
        </div>
        <div class="col">
          <button
            col="12"
            type="submit"
            class="btn action-c-btn btn-success removewrap"
           @click.prevent="handleSubmit(checkEmptyTiers)"
          >
            <img src="/img/correct.0d4e03c5.svg" />
            {{ $t("addNewPricing.assign") }}
          </button>
        </div>
      </div>
    </footer>

                            <cAlertModal v-if="isShowAlertModal"
       :key="'alertModal'+confirmText"
        :buttonList="modalButton"
        :status="modalStatus"
        :show="isShowAlertModal"
        :desc="confirmText"
      ></cAlertModal>


      
                            <cAlertModal v-if="showEmptyTierAlert"
       :key="'alertModal'+confirmText"
        :buttonList="getEmptyAlertModalBtns()"
        :status="0"
        :show="showEmptyTierAlert"
        :desc='$t("addNewPricing.emptyTierDesc")'
      ></cAlertModal>
    </CCard>
      </CForm>
</ValidationObserver>
</template>
<script>
import router ,{navigate,goBack ,updateDataEdited}from "./../../router/index";

import _ from "lodash";
import { mapGetters, mapActions } from "vuex";
import { COMPONENT_NAME, PATHNAME,ALERT_MODAL_STATUS ,ORDER,DATE_TIME_FORMAT} from "./../../util/constants";
import SERVICE_URL, {
  FILE_NAME,
  LOG_TYPE,
  HTTP_CODES
} from "./../../config/API_DATA";
import { VALIDATE_SUCCESS_RES, getErrorMessage } from "../../util/apiValidate";
import BaseConfiguration from "../../config/base.js";
import Logger from "./../../services/logger";
import { handleJWT, getErrorAlertValue ,addClassToBody,removeClassBody,OrderByTwoProp} from "../../util/util";
//import flightDatePicker from "vue-flight-datepicker";
import HotelDatePicker from 'vue-range-datechooser';
import apiUpdateAssignedTiers from "../../services/apiUpdateAssignedTiers";
import { formatDate, addDays, isPastDate } from "../../util/date/dateFunctions";
import cAgent from "../../components/form/cAgent";
import cAlertModal from "./../../components/form/cAlertModal";
import apiAllPricingTiers from "../../services/apiAllPricingTiers";
import apiAssignTiers from "../../services/apiAssignTiers";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
// import nb from "../../translations/validation/nb.json";
// import en from "../../translations/validation/en.json";
import datePickerInput from "../../components/datePicker/datePickerInput";
import {VMdDateRangePicker} from "material-vue-date-picker";
// localize({
//   en: {
//     messages: en.messages
//   },
//   nb: {
//     messages: nb.messages
//   }
// });
export default {
  name: COMPONENT_NAME.ADD_NEW_PRICING,

  components: {
    //flightDatePicker,
    HotelDatePicker,
    ValidationObserver,
    cAgent,
    cAlertModal,
    datePickerInput,
    VMdDateRangePicker,
  },

  data() {
    return {
      labelIcon: {
        labelOn: "\u2713"
        //  labelOff: '\u2715'
      },
      selectedPricingList: [],
      pricingList: [],
      pricingFields: [],
      alertValue: null,
      showEmptyTierAlert:false,
      modalButton: [],
      isShowAlertModal: false,
      modalStatus:ALERT_MODAL_STATUS.SUCCESS,
      confirmText: null,
      // agents: {
      //   b2bid: null,
      //   b2bcode: null,
      //   agencyname: null,
      //   contact_city: null,
      //   isactive: true
      // },
      agents:null,
      pricingResponse: null,
      assignedAgentList : [],
      isNavigateToAssTier:false,
      referenceDate: new Date()
    };
  },

  methods: {




checkEmptyTiers() {
    try {
      if(BaseConfiguration.isDebug) console.log("checkEmptyTiers");

      if(this.selectedPricingList)
      {
       if( this.selectedPricingList[0].tiers && !(this.selectedPricingList[0].tiers.some(v=>v.isEnable)))
       {
            this.toggleEmptyTierAlert();
       }
       else{
           this.confirmPricing()
       }
      }
      
    } catch (err) {
            let body = Logger.buildRequest(
              FILE_NAME.ADD_NEW_PRICING,
              "error in checkEmptyTiers",
              err.toString(),
              "checkEmptyTiers",
              LOG_TYPE.ERROR
            );
            Logger.getResponse(body);
          }
 
    }, 

toggleEmptyTierAlert() {
    try {
      if(BaseConfiguration.isDebug) console.log("toggleEmptyTierAlert");
     this.showEmptyTierAlert = ! this.showEmptyTierAlert;
    } catch (err) {
            let body = Logger.buildRequest(
              FILE_NAME.ADD_NEW_PRICING,
              "error in toggleEmptyTierAlert",
              err.toString(),
              "toggleEmptyTierAlert",
              LOG_TYPE.ERROR
            );
            Logger.getResponse(body);
          }
       
    }, 

    getEmptyAlertModalBtns() {
       let retValue;
        try {
          if(BaseConfiguration.isDebug) console.log("getEmptyAlertModalBtns");
         

         retValue=[
           {
                 name: this.$t("assignPricing.ok"),
                 func: this.toggleEmptyTierAlert
           }
         ]
    
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.ADD_NEW_PRICING,
                  "error in getEmptyAlertModalBtns",
                  err.toString(),
                  "getEmptyAlertModalBtns",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
        }, 


     onChangeDate(pDateList,pTier) {
          try {
            if(BaseConfiguration.isDebug) console.log("onChangeDate");
          //  console.error(pDateList)
        //    this.fromDate=pDateList[0]._d;
           this.getFromDate(pDateList[0]._d,pTier);
           this.getToDate(pDateList[1]._d,pTier);
            //  this.toDate=pDateList[1]._d;
          } catch (err) {
                  let body = Logger.buildRequest(
                    FILE_NAME.ADD_NEW_PRICING,
                    "error in onChangeDate",
                    err.toString(),
                    "onChangeDate",
                    LOG_TYPE.ERROR
                  );
                  Logger.getResponse(body);
                }
            
          }, 

              getMinYear() {
         let retValue;
          try {
            if(BaseConfiguration.isDebug) console.log("getMinYear");
           retValue=(new Date().getFullYear()-10)+'';
      
          } catch (err) {
                  let body = Logger.buildRequest(
                    FILE_NAME.ADD_NEW_PRICING,
                    "error in getMinYear",
                    err.toString(),
                    "getMinYear",
                    LOG_TYPE.ERROR
                  );
                  Logger.getResponse(body);
                }
            return retValue;
          }, 
      getMaxYear() {
         let retValue;
          try {
            if(BaseConfiguration.isDebug) console.log("getMaxYear");
           retValue=(new Date().getFullYear()+1)+'';
      
          } catch (err) {
                  let body = Logger.buildRequest(
                    FILE_NAME.ADD_NEW_PRICING,
                    "error in getMaxYear",
                    err.toString(),
                    "getMaxYear",
                    LOG_TYPE.ERROR
                  );
                  Logger.getResponse(body);
                }
            return retValue;
          }, 

    onToggleSwitch() {
        try {
          if(BaseConfiguration.isDebug) console.log("onToggleSwitch");
      updateDataEdited(true);

        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.ADD_NEW_PRICING,
                  "error in onToggleSwitch",
                  err.toString(),
                  "onToggleSwitch",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
        }, 
   
    showAlert(val) {
      this.alertValue = val;
    },
    toggleAlertModal()
    {
      if (BaseConfiguration.isDebug) console.log("toggleAlertModal");
           this.isShowAlertModal =! this.isShowAlertModal;
    },

    showAlertModal(status,val) {
      this.isShowAlertModal = true;
      // this.isNavigateToAssTier=false;
      this.modalStatus=status;
      if(this.modalStatus == ALERT_MODAL_STATUS.INFO){
      this.modalButton = [


         {
          name: this.$t("assignPricing.no"),
          func: this.toggleAlertModal,
          color: "success"
        },
        {
          name: this.$t("assignPricing.yes"),
          func: (this.selectedPricing?this.updatePricing:this.assignPricing), 
          color: "success"
        }
      ];
      }else if(this.modalStatus == ALERT_MODAL_STATUS.SUCCESS){
        this.modalButton = [
        {
          name: this.$t("assignPricing.ok"),
          func: this.navigateToAssignPricing,
          color: "success"
        }
      ];
      }
      this.confirmText = val;
    },

    navigateToAssignPricing() {
      this.isShowAlertModal = false;
      navigate(
       PATHNAME.ASSIGN_PRICING
      );
    },
    
    ///to navigate to assign pricing page while click cancel
    navToAssPricWhileCancel() {
      this.isNavigateToAssTier=true;
      this.isShowAlertModal = false;
      navigate(
       PATHNAME.ASSIGN_PRICING
      );
    },

    getB2bid(pAgent) {
      this.selectedPricingList[0].b2bId = pAgent.b2bid;
      this.selectedPricingList[0].agentName=pAgent.agencyname;
            this.selectedPricingList[0].agencyCode=pAgent.b2bcode;

    },

     assigni18nObjByLang(item) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("assigni18nObjByLang");

        retValue = {
          night: this.$t("flightDatePicker.night"),
          nights: this.$t("flightDatePicker.nights"),
          "day-names": [
            this.$t("flightDatePicker.sun"),
            this.$t("flightDatePicker.mon"),
            this.$t("flightDatePicker.tue"),
            this.$t("flightDatePicker.wed"),
            this.$t("flightDatePicker.thur"),
            this.$t("flightDatePicker.fri"),
            this.$t("flightDatePicker.sat")
          ],
          "check-in": "",
          //"check-out": "",
          "check-out": formatDate(addDays(new Date(item.fromDate),1),
                    "DD MMM YYYY"
                  ), 
          "month-names": [
            this.$t("flightDatePicker.jan"),
            this.$t("flightDatePicker.feb"),
            this.$t("flightDatePicker.mar"),
            this.$t("flightDatePicker.apr"),
            this.$t("flightDatePicker.may"),
            this.$t("flightDatePicker.jun"),
            this.$t("flightDatePicker.july"),
            this.$t("flightDatePicker.aug"),
            this.$t("flightDatePicker.sep"),
            this.$t("flightDatePicker.oct"),
            this.$t("flightDatePicker.nov"),
            this.$t("flightDatePicker.dec")
          ]
        };
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.ADD_NEW_PRICING,
          "error in assigni18nObjByLang",
          err.toString(),
          "assigni18nObjByLang",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    confirmPricing() {
        try {
          if(BaseConfiguration.isDebug) console.log("confirmPricing");
          let pricing=[];
         for (let index = 0; index < this.selectedPricingList[0].tiers.length; index++) {
           const pList = this.selectedPricingList[0].tiers[index];
          //  if(pList.isEnable==true){
          //   //  let pObj = {
          //   //    tier:pList.tierName,
          //   //    from:pList.fromDate,
          //   //    to:pList.toDate
          //   //  }
          //   //  pricing.push(pObj);
          //  let priText= pList.tierName + " - from " + pList.fromDate + " to " + pList.toDate;
          //  pricing.push(priText);
           //}
         }
           let confirmText =  this.$t("addNewPricing.confirmText", {
             // pricing: pricing+ this.$t("\n"),               
              agent: this.selectedPricingList&&this.selectedPricingList[0]&& this.selectedPricingList[0].agentName?this.selectedPricingList[0].agentName:this.selectedPricing&&this.selectedPricing.agentName?this.selectedPricing.agentName:'',
              agencyCode:this.selectedPricingList&&this.selectedPricingList[0]&&this.selectedPricingList[0].agencyCode ?this.selectedPricingList[0].agencyCode:this.selectedPricing&&this.selectedPricing.agencyCode?this.selectedPricing.agencyCode:''
             // toDate: this.creditNote.agents.agencyname
            });
            this.isNavigateToAssTier=false;
           this.showAlertModal(ALERT_MODAL_STATUS.INFO,confirmText);

         
    
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.assignPricing,
                  "error in confirmPricing",
                  err.toString(),
                  "confirmPricing",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
        //  return retValue;
        }, 
        getAgencyCode() {
            try {
              if(BaseConfiguration.isDebug) console.log("getAgencyCode");
             
        
            } catch (err) {
                    let body = Logger.buildRequest(
                      FILE_NAME.ASSIGN_PRICING,
                      "error in getAgencyCode",
                      err.toString(),
                      "getAgencyCode",
                      LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                  }
             
            }, 

    getPricingList(selectedPricing,priRes) {
      try {
        if (BaseConfiguration.isDebug) console.log("getPricingList");
        // let retValue;

        let priList = [];

         if (priRes) {
           let pObj = {
             b2bId : selectedPricing?selectedPricing.b2bId:this.agents?this.agents.b2bid:null,
             agentName : selectedPricing?selectedPricing.agentName:this.agents?this.agents.agencyname:null,
             tiers: []
           }
           
            if(selectedPricing && selectedPricing.pricing && selectedPricing.pricing.length){
             for (let index = 0; index < selectedPricing.pricing.length; index++) {
              const selList = selectedPricing.pricing[index];
              let tObj = {
              tierName: selList.tier.name,
              tierid: selList.tier.tierid,
              fromDate:selList.fromDate,
              toDate: selList.toDate,
              isEnable:true
            };
             pObj.tiers.push(tObj);  
           }
           }
           let pricing=selectedPricing? _.differenceBy(priRes, pObj.tiers, 'tierid'):priRes;
           for (let index = 0; index < pricing.length; index++) {
             const resList = pricing[index];
             let tObj = {
              tierName: resList.name,
              tierid: resList.tierid,
              fromDate: formatDate(new Date(), DATE_TIME_FORMAT.API_DATE_FORMAT),
              toDate: formatDate(addDays(new Date(),1),
                    DATE_TIME_FORMAT.API_DATE_FORMAT
                  ),
              isEnable:false
            };
            pObj.tiers.push(tObj);  
             
           }
          
           priList.push(pObj);
         } 

        // if (selectedPricing) {
        //   let pObj = {
        //     b2bId: selectedPricing.b2bId
        //       ? selectedPricing.b2bId
        //       : this.agents.b2bid,
        //     tiers: []
        //   };
        //   let pricing = selectedPricing.pricing
        //     ? selectedPricing.pricing
        //     : selectedPricing;
        //   for (let index = 0; index < pricing.length; index++) {
        //     const pList = pricing[index];

        //     let tObj = {
        //       tierName: pList.tier ? pList.tier.name : pList.name,
        //       tierid: pList.tier ? pList.tier.tierid : pList.tierid,
        //       fromDate: pList.fromDate
        //         ? pList.fromDate
        //         : formatDate(new Date(), DATE_TIME_FORMAT.API_DATE_FORMAT),
        //       toDate: pList.toDate
        //         ? pList.toDate
        //         : formatDate(addDays(new Date(),1),
        //             DATE_TIME_FORMAT.API_DATE_FORMAT
        //           ),
        //       isEnable: selectedPricing.b2bId ? true : false
        //     };
        //     pObj.tiers.push(tObj);
        //   }
        //   priList.push(pObj);
        // }
         
        return priList;
          
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.ADD_NEW_PRICING,
          "error in getPricingList",
          err.toString(),
          "getPricingList",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      // return retValue;
    },

    getPricingFields() {
      if (BaseConfiguration.isDebug) console.log("getPricingFields");
      return [
        {
          key: "pricingname",
          label: this.$t("addNewPricing.status")
        },

        {
          key: "bookingDate",
          label: this.$t("addNewPricing.booking")
        }
      ];
    },

    getFromDate(date, tier) {
      try {
        if (BaseConfiguration.isDebug) console.log("getFromDate");
        //let retValue;
        
        if (tier && date) {
          if(!isPastDate(date,tier.fromDate)){
          this.showAlert(null);
          this.updateDate(date, tier, true);
          }
          else
          this.showAlert(this.$t("createPricing.pastDate"));
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.ADD_NEW_PRICING,
          "error in getFromDate",
          err.toString(),
          "getFromDate",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      // return retValue;
    },

    getToDate(date, tier) {
      try {
        if (BaseConfiguration.isDebug) console.log("getToDate");
        //let retValue;
        if (tier && date) {
          if(!isPastDate(date,tier.fromDate)){
          this.updateDate(date, tier, false);
          }
          else
          this.showAlert(this.$t("createPricing.pastDate"));
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.ADD_NEW_PRICING,
          "error in getToDate",
          err.toString(),
          "getToDate",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      // return retValue;
    },

    updateDate(date, tier, isFromDate) {
      try {
        if (BaseConfiguration.isDebug) console.log("updateDate");
        if (tier) {
          for (
            let index = 0;
            index < this.selectedPricingList.length;
            index++
          ) {
            const pList = this.selectedPricingList[index].tiers;
            for (let list = 0; list < pList.length; list++) {
              const tList = pList[list];
              if (tList.tierid == tier.tierid) {
                if (tList.isEnable == true) {
                  if (isFromDate) {
                    tList.fromDate = formatDate(new Date(date), DATE_TIME_FORMAT.API_DATE_FORMAT);
                    tList.toDate= formatDate(addDays(new Date( tList.fromDate),1),
                    DATE_TIME_FORMAT.API_DATE_FORMAT
                  );
                  } else {
                    tList.toDate = formatDate(new Date(date), DATE_TIME_FORMAT.API_DATE_FORMAT);
                  }
                }
              }
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.ADD_NEW_PRICING,
          "error in updateDate",
          err.toString(),
          "updateDate",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    getAssignedAgentList(tierList) {
        try {
          if(BaseConfiguration.isDebug) console.log("getAssignedAgentList");
         // let retValue;
         let agentList=[];
         if(tierList){
            for (let tRes of Object.entries(tierList)) {
            let agentObj = {
              b2bid: tRes[0],
              agent: tRes[1].agent
            };
            agentList.push(agentObj); 
           }
         }
         return agentList;
    
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.ADD_NEW_PRICING,
                  "error in getAssignedAgentList",
                  err.toString(),
                  "getAssignedAgentList",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
         // return retValue;
        }, 

    async getPricingResponse() {
      try {
        if (BaseConfiguration.isDebug) console.log("getPricingResponse");
        let retValue= {
        tierList : [],
        permission : {}
        };

        let pricingReq = apiAllPricingTiers.buildRequest("ACTIVE");

        if (pricingReq) {
          let pricingRes = await apiAllPricingTiers.getResponse(pricingReq);
          if (VALIDATE_SUCCESS_RES(pricingRes)) {
            // retValue = pricingRes.data.data;
            retValue.tierList = pricingRes.data.data.tiersList;
           retValue.permission = pricingRes.data.data.permission;
            // this.showAlert(null);
          } else {
            let error = getErrorMessage(pricingRes);
            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.showAlert(getErrorAlertValue(error));
            }
          }
        } else {
          throw "invalid request";
        }
        return retValue;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.ADD_NEW_PRICING,
          "error in getPricingResponse",
          err.toString(),
          "getPricingResponse",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    async updatePricing() {
      try {
        if (BaseConfiguration.isDebug) console.log("updatePricing");
        //let retValue;
        let req = JSON.parse(JSON.stringify(this.selectedPricingList));

        let updateRequest = apiUpdateAssignedTiers.buildRequest(req);

        if (updateRequest) {
          let updateResponse = await apiUpdateAssignedTiers.getResponse(
            updateRequest
          );
          if (VALIDATE_SUCCESS_RES(updateResponse)) {
            // retValue = updateResponse.data.data;
            this.showAlertModal(ALERT_MODAL_STATUS.SUCCESS,this.$t("assignPricing.updateSuccess",{name:this.selectedPricingList[0].agentName}));
            // this.showAlert(null);
          } else {
             this.isShowAlertModal = false;
            let error = getErrorMessage(updateResponse);
            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.showAlert(getErrorAlertValue(error));
            }
          }
        } else {
          throw "invalid request";
        }
        updateDataEdited(false);
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.ADD_NEW_PRICING,
          "error in updatePricing",
          err.toString(),
          "updatePricing",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      // return retValue;
    },

    async assignPricing() {
      try {
        if (BaseConfiguration.isDebug) console.log("assignPricing");
        //let retValue;
        let req = JSON.parse(JSON.stringify(this.selectedPricingList));

        let assignRequest = apiAssignTiers.buildRequest(req);

        if (assignRequest) {
          let assignResponse = await apiAssignTiers.getResponse(assignRequest);
          if (VALIDATE_SUCCESS_RES(assignResponse)) {
            // retValue = updateResponse.data.data;
            this.showAlertModal(ALERT_MODAL_STATUS.SUCCESS,this.$t("assignPricing.assignSuccess",{name:this.selectedPricingList[0].agentName}));
            //this.showAlert(null);
          } else {
           this.isShowAlertModal = false;
            let error = getErrorMessage(assignResponse);
            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.showAlert(getErrorAlertValue(error));
            }
          }
        } else {
          throw "invalid request";
        }
         updateDataEdited(false); 
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.ADD_NEW_PRICING,
          "error in assignPricing",
          err.toString(),
          "assignPricing",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      // return retValue;
    },
    getPropToSortPricingLs(pTier) {
        try {
          if(BaseConfiguration.isDebug) console.log("getPropToSortPricingLs");
          if(pTier.hasOwnProperty('isEnable')){
            return pTier.isEnable;
          }
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.ADD_NEW_PRICING,
                  "error in getPropToSortPricingLs",
                  err.toString(),
                  "getPropToSortPricingLs",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
        }, 

        getPropToSortPricLsByName(pTier) {
        try {
          if(BaseConfiguration.isDebug) console.log("getPropToSortPricLsByName");
          if(pTier.tierName){
            return pTier.tierName.toLowerCase();
          }
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.ADD_NEW_PRICING,
                  "error in getPropToSortPricLsByName",
                  err.toString(),
                  "getPropToSortPricLsByName",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
        }, 
  },
 
  computed: {
    ...mapGetters("sAssignPricing", {
      selectedPricing: "GET_SELECTED_PRICING"
    }),
    ...mapGetters("sAssignPricing", {
      selectedTier: "GET_SELECTED_TIER"
    }),
      ...mapGetters("sApproveAgt", {
               
                GET_APPROVE_AGENT_RES: "GET_APPROVE_AGENT_RES"
            }),
   
  },

  async created() {
    if (BaseConfiguration.isDebug) console.log("created");

    if(this.selectedTier)
    this.assignedAgentList= this.getAssignedAgentList(this.selectedTier);

    this.pricingResponse= await this.getPricingResponse(); 
 
      this.pricingList = this.getPricingList(JSON.parse(JSON.stringify(this.selectedPricing?this.selectedPricing:null)),
        JSON.parse(JSON.stringify( this.pricingResponse.tierList?this.pricingResponse.tierList:null))
      );
  //       if (this.selectedPricing) {
  //     this.pricingList = this.getPricingList(
  //       await JSON.parse(JSON.stringify(this.selectedPricing))
  //     );
  //   } else {
  //     this.pricingList = this.getPricingList(
  //       await JSON.parse(JSON.stringify(await this.getPricingResponse()))
  //     );
  // }
    
    this.selectedPricingList = JSON.parse(JSON.stringify(this.pricingList?this.pricingList:{}));
    if( this.selectedPricingList&&  this.selectedPricingList[0]&&this.selectedPricingList[0].tiers)
    {
     this.selectedPricingList[0].tiers=OrderByTwoProp(this.selectedPricingList[0].tiers,this.getPropToSortPricingLs,this.getPropToSortPricLsByName,
    ORDER.DESC, ORDER.ASC);
    }
  
    this.pricingFields = this.getPricingFields();

  },
   beforeCreate() {    
   addClassToBody(COMPONENT_NAME.ADD_NEW_PRICING);
  },
  
   beforeDestroy() {
       removeClassBody();
    },
};
</script>

